import React from 'react'
import { createRoot } from 'react-dom/client'
import settings from 'src/settings'
import App from './App'

// Same as src/index.tsx: without nginx (Vite dev server), replace the raw
// instance marker left in <title> (#105).
document.title = settings.brand.name

const root = createRoot(document.getElementById('root')!)

root.render(<App />)
